import { NetworkResponse } from '../../../@packages/dataFetch';
import { isBadOrEmptyString } from '../../../predicates/string';
import { isUndefined } from '../../../predicates/type';
import { handlePOSTRequest } from './utils';

function gaNetworkHandler(response?: NetworkResponse) {
	if (isUndefined(response) || isUndefined(response.config)) {
		return;
	}

	const method = response?.config?.method;

	if (isBadOrEmptyString(method) || response.status !== 200) {
		return;
	}

	if (String(method).toUpperCase() === 'POST') {
		handlePOSTRequest(response);
	}
}

export { gaNetworkHandler };
